<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("reports.breederReport") }}</h2>
      </div>

      <!-- filters -->
      <v-row no-gutters>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="countries"
            item-text="name"
            item-value="id"
            dense
            outlined
            class="shrink mr-2"
            v-model="countary"
            :placeholder="$t('reports.filterByCountry')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink mr-2"
            v-model="region"
            :placeholder="$t('reports.filterByRegion')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-autocomplete
            v-model="farm"
            :items="farmsList"
            item-text="name"
            item-value="farmNumber"
            dense
            :loading="farmLoading"
            :search-input.sync="farmSearch"
            outlined
            v-on:change="getProductByCat"
            hide-no-data
            :placeholder="$t('reports.filterByFarm')"
            class="mr-2 wdt"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink mr-2"
            v-model="region"
            :placeholder="$t('reports.filterByMonth')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink mr-2"
            v-model="region"
            :placeholder="$t('reports.filterByDate')"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="3" md="2">
          <v-select
            :items="regions"
            item-text="name"
            item-value="roleNumber"
            dense
            outlined
            class="shrink"
            v-model="region"
            :placeholder="$t('reports.filterByRole')"
          ></v-select>
        </v-col>
      </v-row>

      <!-- chips -->
      <v-row no-gutters>
        <v-col cols="12" sm="4" md="4">
          <v-card class="mx-auto border rounded-lg" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ count.total_pregnent }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ $t("animal.totalPregnant") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ count.new_born }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ $t("animal.totalNewBorn") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  {{ totalConception }}
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  {{ $t("reportings.totalInsemination") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" sm="3" md="3">
          <v-card class="mx-auto border rounded-lg ml-5" height="120" outlined>
            <v-list-item class="text-end">
              <v-list-item-content class="mr-n4">
                <v-list-item-title class="mt-n3">
                  <v-avatar size="15" color="#DAE1EC"></v-avatar>
                  <v-menu>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="on">
                        <v-icon color="#DAE1EC">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </template>
                  </v-menu>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line class="mt-n11">
              <v-list-item-avatar
                size="70"
                color="#DAE1EC"
              ></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="text-h5 subtitle-2 font-weight-black">
                  20
                </v-list-item-title>
                <v-list-item-subtitle class="mt-n3 font-weight-medium">
                  Total Products
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col> -->
      </v-row>

      <!-- tables -->
      <v-row>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex my-5">
                <p class="mt-2 ml-4">{{ $t("animal.conception") }}</p>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ fromConception }} - {{ toConception }} of
                  {{ totalConception }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsConception.page <= 1"
                  @click="pageChangeConception(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="
                    tableOptionsConception.page >= totalPagesConception
                  "
                  @click="pageChangeConception(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportConception"
                >
                  <v-icon dark> mdi-export </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="
                    printPDF($refs.conception, 'Conception(Breeder Report)')
                  "
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </div>
            </template>
            <div ref="conception">
              <v-data-table
                :headers="headersForConception"
                :items="itemsForConception"
                :items-per-page="5"
                :loading="conceptionLoading"
                hide-default-footer
                :options.sync="tableOptionsConception"
                :server-items-length="totalConception"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>

                <template v-slot:[`item.conceptionMethod`]="{ item }">
                  {{ item.conceptionMethod }}
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex my-5">
                <p class="mt-2 ml-4">{{ $t("conceptionInfo.semen") }}</p>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ fromSemen }} - {{ toSemen }} of {{ totalgenos }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsSemen.page <= 1"
                  @click="pageChangeSemen(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="
                    tableOptionsSemen.page >= totalPagesConceptionSemen
                  "
                  @click="pageChangeSemen(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportSemen"
                >
                  <v-icon dark> mdi-export </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="printPDF($refs.semen, 'Semen(Breeder Report)')"
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </div>
            </template>
            <div ref="semen">
              <v-data-table
                :headers="headersForSemen"
                :items="itemsForSemen"
                :items-per-page="5"
                :loading="semenLoading"
                hide-default-footer
                :options.sync="tableOptionsSemen"
                :server-items-length="totalgenos"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex my-5">
                <p class="mt-2 ml-4">{{ $t("reportings.embryo") }}</p>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ fromEmbryo }} - {{ toEmbryo }} of
                  {{ totalEmbryo }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsEmbryo.page <= 1"
                  @click="pageChangeEmbryo(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="
                    tableOptionsEmbryo.page >= totalPagesConceptionEmbryo
                  "
                  @click="pageChangeEmbryo(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportEmbryo"
                >
                  <v-icon dark> mdi-export </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="printPDF($refs.embryo, 'Embryo(Breeder Report)')"
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </div>
            </template>
            <div ref="embryo">
              <v-data-table
                :headers="headersForEmbryo"
                :items="itemsForEmbryo"
                :loading="embryoLoading"
                :items-per-page="5"
                hide-default-footer
                :options.sync="tableOptionsEmbryo"
                :server-items-length="totalEmbryo"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>

                <template v-slot:[`item.EmbryoMethod`]="{ item }">
                  {{ item.EmbryoMethod.name }}
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex my-5">
                <p class="mt-2 ml-4">{{ $t("conceptionInfo.pregnancyCheck") }}</p>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ fromPregnancyCheck }} - {{ toPregnancyCheck }} of
                  {{ totalPregnancyCheck }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsPregnancyCheck.page <= 1"
                  @click="pageChangeCheck(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="
                    tableOptionsPregnancyCheck.page >=
                    totalPagesConceptionPregnancyCheck
                  "
                  @click="pageChangeCheck(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportPregnancy"
                >
                  <v-icon dark> mdi-export </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="
                    printPDF($refs.pregnancy, 'Pregnancy(Breeder Report)')
                  "
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </div>
            </template>
            <div ref="pregnancy">
              <v-data-table
                :headers="headersForPregnancyCheck"
                :items="itemsForPregnancyCheck"
                :items-per-page="5"
                hide-default-footer
                :loading="pregnancyLoading"
                :options.sync="tableOptionsPregnancyCheck"
                :server-items-length="totalPregnancyCheck"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="12">
          <v-card
            class="mx-auto border rounded-lg mx-9 mt-5"
            elevation="0"
            outlined
          >
            <template>
              <div class="d-flex my-5">
                <p class="mt-2 ml-4">{{ $t("conceptionInfo.birthInfo") }}</p>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ fromBirthInfo }} - {{ toBirthInfo }} of
                  {{ totalBirthInfo }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptionsBirthInfo.page <= 1"
                  @click="pageChangeBirth(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="
                    tableOptionsBirthInfo.page >= totalPagesConceptionBirthInfo
                  "
                  @click="pageChangeBirth(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="exportbirth"
                >
                  <v-icon dark> mdi-export </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="printPDF($refs.birth, 'Birth(Breeder Report)')"
                >
                  <v-icon dark> mdi-printer </v-icon>
                </v-btn>
              </div>
            </template>
            <div ref="birth">
              <v-data-table
                :headers="headersForBirthInfo"
                :items="itemsForBirthInfo"
                :items-per-page="5"
                :loading="birthLoading"
                hide-default-footer
                :options.sync="tableOptionsBirthInfo"
                :server-items-length="totalBirthInfo"
              >
                <template v-slot:progress>
                  <v-progress-linear
                    color="primary"
                    :height="8"
                    indeterminate
                  ></v-progress-linear>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Breadcrumb from "@/components/core/Breadcrumb";
import FarmService from "@/_services/farmService.js";
import ProductService from "@/_services/ReportingService.js";
import loadingMixin from "@/mixins/LoadingMixin";
import html2pdf from "html2pdf.js";
import printJS from "print-js";

export default {
  components: {
    breadcrumb: Breadcrumb,
  },
  
  mounted() {
    document.title = this.$t('reports.analyticsAndReporting');
    this.searchFarm(this.farm);
    this.getCount();
  },
  watch: {
    farmSearch(val) {
      this.searchFarm(val);
    },
    tableOptionsConception: {
      handler() {
        this.getConception();
      },
      deep: true,
    },
    tableOptionsSemen: {
      handler() {
        this.getSemen();
      },
      deep: true,
    },
    tableOptionsBirthInfo: {
      handler() {
        this.getBirthInfo();
      },
      deep: true,
    },
    tableOptionsEmbryo: {
      handler() {
        this.getEmbryo();
      },
      deep: true,
    },
    tableOptionsPregnancyCheck: {
      handler() {
        this.getPregnancyCheck();
      },
      deep: true,
    },
  },
  data() {
    return{
      countries: [],
      regions: [],
      data: "",
      countary: null,
      region: null,
      farmsList: [],
      farm: "FRM000011018186",
      items: [],
      conceptionLoading: false,
      semenLoading: false,
      embryoLoading: false,
      pregnancyLoading: false,
      birthLoading: false,
      newItems: [],
      farmLoading: false,
      farmSearch: "",
      search: "",
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('reports.analyticsAndReporting'),
          disabled: true,
        },
        {
          text: this.$t('reports.breederReport'),
          disabled: true,
        },
      ],
      count: {},
      headersForSemen: [
        { text: this.$t('reports.semenTransferDate'), sortable: false, value: "matingDate" },
        { text: this.$t('dashboardS.sireId'), sortable: false, value: "sireId" },
        { text: this.$t('reports.semenStrawId'), sortable: false, value: "strawId" },
        { text: this.$t('dashboardS.damID'), sortable: false, value: "surrogateDamBreedId" },
        { text: this.$t('dashboardS.orgName'), sortable: false, value: "embryoOrgName" },
        { text: this.$t('dashboardS.damBreed'), sortable: false, value: "surrogateDamBreed" },
        { text: this.$t('dashboardS.sireBreed'), sortable: false, value: "sireBreed" },
      ],

      itemsForSemen: [],

      headersForEmbryo: [
        { text: this.$t('conceptionInfo.embryoTransferDate'), sortable: false, value: "matingDate" },
        { text: this.$t('dashboardS.sireId'), sortable: false, value: "sireId" },
        { text: this.$t('dashboardS.damID'), sortable: false, value: "surrogateDamId" },
        { text: this.$t('dashboardS.embOrgName'), sortable: false, value: "embryoOrgName" },
        { text: this.$t('reports.receipientId'), sortable: false, value: "receipientId" },
        { text: this.$t('reports.embryoId'), sortable: false, value: "embryoId" },
      ],
      itemsForEmbryo: [],

      headersForConception: [
        { text: this.$t('animal.inseminationDate'), sortable: false, value: "matingDate" },
        { text: this.$t('animal.inseminatorName'), sortable: false, value: "inseminatorName" },
        { text: this.$t('dashboardS.orgName'), sortable: false, value: "orgName" },
        {
          text: this.$t('dashboardS.brServiceNum'),
          sortable: false,
          value: "breedingServiceNo",
        },
        {
          text: this.$t('dashboardS.conceptionMethod'),
          sortable: false,
          value: "conceptionMethod.name",
        },
      ],
      itemsForConception: [],

      headersForPregnancyCheck: [
        {
          text: this.$t('conceptionInfo.pregnancyCheckDate'),
          sortable: false,
          value: "pregnancyCheckDate",
        },
        { text: this.$t('conceptionInfo.daysOfPregnancy'), sortable: false, value: "days" },
        { text: this.$t('reportings.pregnancyStatus'), sortable: false, value: "conceptionSuccess" },
        {
          text: this.$t('conceptionInfo.pregnancyCheckOperator'),
          sortable: false,
          value: "pregnancyCheckOperatorName",
        },
        {
          text: this.$t('conceptionInfo.pregnancyCheckMethod'),
          sortable: false,
          value: "pregnancyCheckMethod",
        },
      ],
      itemsForPregnancyCheck: [],

      headersForBirthInfo: [
        { text: this.$t('conceptionInfo.deliveryDate'), sortable: false, value: "deliveryDate" },
        { text: this.$t('conceptionInfo.calfId'), sortable: false, value: "calfId" },
        { text: this.$t('animal.birthFarm'), sortable: false, value: "birthFarm" },
        { text: this.$t('animal.birthEase'), sortable: false, value: "birthEase.name" },
        {
          text: this.$t('conceptionInfo.birthDayOldWeight'),
          sortable: false,
          value: "birthWeight",
        },
      ],
      itemsForBirthInfo: [],

      tableOptionsSemen: {
        page: 1,
        itemsPerPage: 5,
      },
      fromSemen: 0,
      toSemen: 0,
      totalgenos: 1,
      totalPagesConceptionSemen: 1,

      tableOptionsEmbryo: {
        page: 1,
        itemsPerPage: 5,
      },
      fromEmbryo: 0,
      toEmbryo: 0,
      totalEmbryo: 1,
      totalPagesConceptionEmbryo: 1,

      tableOptionsConception: {
        page: 1,
        itemsPerPage: 5,
      },
      fromConception: 0,
      toConception: 0,
      totalConception: 1,
      totalPagesConception: 1,

      tableOptionsPregnancyCheck: {
        page: 1,
        itemsPerPage: 5,
      },
      fromPregnancyCheck: 0,
      toPregnancyCheck: 0,
      totalPregnancyCheck: 1,
      totalPagesConceptionPregnancyCheck: 1,

      tableOptionsBirthInfo: {
        page: 1,
        itemsPerPage: 5,
      },
      fromBirthInfo: 0,
      toBirthInfo: 0,
      totalBirthInfo: 1,
      totalPagesConceptionBirthInfo: 1,
    }
  },
  methods: {
    searchFarm(val) {
      if (val == "" || val == null) return;
      this.farmsLoading = true;
      FarmService.searchFarms(val)
        .then((res) => {
          console.log(res);
          this.farmsList = res.data.farms;
        })
        .catch((err) => {
          console.log(err);
          // this.users = [];
        })
        .finally(() => (this.farmsLoading = false));
    },

    getCount() {
      this.startLoading();
      ProductService.getCountbreeder()
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.count = res.data;
            this.stopLoading();
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    exportConception() {
      html2pdf(this.$refs.conception, {
        margin: 1,
        filename: "Conception Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportSemen() {
      html2pdf(this.$refs.semen, {
        margin: 1,
        filename: "Semen Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportEmbryo() {
      html2pdf(this.$refs.embryo, {
        margin: 1,
        filename: "Embryo Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportPregnancy() {
      html2pdf(this.$refs.pregnancy, {
        margin: 1,
        filename: "Pregnancy Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    exportbirth() {
      html2pdf(this.$refs.birth, {
        margin: 1,
        filename: "Birth Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 200, letterRendering: true },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "landscape",
          compress: false,
        },
      });
    },
    async printPDF(reference, title) {
      let opt = {
        margin: 1,
        filename: `${title}.pdf`,
        image: { type: "jpeg", quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      let worker = await html2pdf()
        .set(opt)
        .from(reference)
        .toCanvas()
        .outputPdf("blob", `${title}.pdf`);
      let file = new File([worker], `${title}.pdf`, {
        type: "application/pdf",
      });
      var pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: "pdf", showModal: true });
    },
    getConception() {
      this.conceptionLoading = true;
      ProductService.getConception(this.tableOptionsConception, this.farm)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.itemsForConception = res.data.conceptionData.rows;
            this.currentrows = res.data.conceptionData.num_rows;
            this.totalConception = res.data.conceptionData.total_rows;
            this.pageCount = Math.ceil(
              this.totalConception / this.tableOptionsConception.itemsPerPage
            );
            this.totalPagesConception = Math.ceil(
              this.totalConception / this.tableOptionsConception.itemsPerPage
            );
            this.fromConception =
              (this.tableOptionsConception.page - 1) *
                this.tableOptionsConception.itemsPerPage +
              1;
            this.toConception =
              this.tableOptionsConception.page *
                this.tableOptionsConception.itemsPerPage -
              (this.tableOptionsConception.itemsPerPage -
                res.data.conceptionData.num_rows);
            this.conceptionLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeConception(t) {
      if (t)
        this.tableOptionsConception.page = this.tableOptionsConception.page + 1;
      else
        this.tableOptionsConception.page = this.tableOptionsConception.page - 1;

      this.getConception();
    },
    getSemen() {
      this.semenLoading = true;
      ProductService.getSemenDetails(this.tableOptionsSemen, this.farm)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.itemsForSemen = res.data.semenData.rows;
            this.currentrows = res.data.semenData.num_rows;
            this.totalgenos = res.data.semenData.total_rows;
            this.pageCount = Math.ceil(
              this.totalgenos / this.tableOptionsSemen.itemsPerPage
            );
            this.totalPagesConceptionSemen = Math.ceil(
              this.totalConception / this.tableOptionsSemen.itemsPerPage
            );
            this.fromSemen =
              (this.tableOptionsSemen.page - 1) *
                this.tableOptionsSemen.itemsPerPage +
              1;
            this.toSemen =
              this.tableOptionsSemen.page *
                this.tableOptionsSemen.itemsPerPage -
              (this.tableOptionsSemen.itemsPerPage -
                res.data.semenData.num_rows);
            this.semenLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeSemen(t) {
      if (t) this.tableOptionsSemen.page = this.tableOptionsSemen.page + 1;
      else this.tableOptionsSemen.page = this.tableOptionsSemen.page - 1;

      this.getSemen();
    },
    getEmbryo() {
      this.embryoLoading = true;
      ProductService.getEmbroyDetails(this.tableOptionsEmbryo, this.farm)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.itemsForEmbryo = res.data.embryoData.rows;
            this.currentrows = res.data.embryoData.num_rows;
            this.totalEmbryo = res.data.embryoData.total_rows;
            this.pageCount = Math.ceil(
              this.totalEmbryo / this.tableOptionsEmbryo.itemsPerPage
            );
            this.totalPagesConceptionEmbryo = Math.ceil(
              this.totalEmbryo / this.tableOptionsEmbryo.itemsPerPage
            );
            this.fromEmbryo =
              (this.tableOptionsEmbryo.page - 1) *
                this.tableOptionsEmbryo.itemsPerPage +
              1;
            this.toEmbryo =
              this.tableOptionsEmbryo.page *
                this.tableOptionsEmbryo.itemsPerPage -
              (this.tableOptionsEmbryo.itemsPerPage -
                res.data.embryoData.num_rows);
            this.embryoLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeEmbryo(t) {
      if (t) this.tableOptionsEmbryo.page = this.tableOptionsEmbryo.page + 1;
      else this.tableOptionsEmbryo.page = this.tableOptionsEmbryo.page - 1;
      this.getEmbryo();
    },

    getPregnancyCheck() {
      this.pregnancyLoading = true;
      ProductService.getPregnencyCheck(
        this.tableOptionsPregnancyCheck,
        this.farm
      )
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.itemsForPregnancyCheck = res.data.pregrencyCheckData.rows.map(
              (a) => {
                const obj = {
                  pregnancyCheckDate: a.pregnancyCheckDate,
                  conceptionSuccess: a.conceptionSuccess ? "Yes" : "No",
                  pregnancyCheckOperatorName: a.pregnancyCheckOperatorName,
                  pregnancyCheckMethod: a.pregnancyCheckMethod,
                  days: a.days,
                };
                return obj;
              }
            );
            this.currentrows = res.data.pregrencyCheckData.num_rows;
            this.totalPregnancyCheck = res.data.pregrencyCheckData.total_rows;
            this.pageCount = Math.ceil(
              this.totalPregnancyCheck /
                this.tableOptionsPregnancyCheck.itemsPerPage
            );
            this.totalPagesConceptionPregnancyCheck = Math.ceil(
              this.totalPregnancyCheck /
                this.tableOptionsPregnancyCheck.itemsPerPage
            );
            this.fromPregnancyCheck =
              (this.tableOptionsPregnancyCheck.page - 1) *
                this.tableOptionsPregnancyCheck.itemsPerPage +
              1;
            this.toPregnancyCheck =
              this.tableOptionsPregnancyCheck.page *
                this.tableOptionsPregnancyCheck.itemsPerPage -
              (this.tableOptionsPregnancyCheck.itemsPerPage -
                res.data.pregrencyCheckData.num_rows);
            this.pregnancyLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChangeCheck(t) {
      if (t)
        this.tableOptionsPregnancyCheck.page =
          this.tableOptionsPregnancyCheck.page + 1;
      else
        this.tableOptionsPregnancyCheck.page =
          this.tableOptionsPregnancyCheck.page - 1;

      this.getPregnancyCheck();
    },
    getBirthInfo() {
      this.birthLoading = true;
      ProductService.getBirthInfo(this.tableOptionsBirthInfo, this.farm)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.itemsForBirthInfo = res.data.birthInfoData.rows;
            this.currentrows = res.data.birthInfoData.num_rows;
            this.totalBirthInfo = res.data.birthInfoData.total_rows;
            this.pageCount = Math.ceil(
              this.totalBirthInfo / this.tableOptionsBirthInfo.itemsPerPage
            );
            this.totalPagesConceptionBirthInfo = Math.ceil(
              this.totalBirthInfo / this.tableOptionsBirthInfo.itemsPerPage
            );
            this.fromBirthInfo =
              (this.tableOptionsBirthInfo.page - 1) *
                this.tableOptionsBirthInfo.itemsPerPage +
              1;
            this.toBirthInfo =
              this.tableOptionsBirthInfo.page *
                this.tableOptionsBirthInfo.itemsPerPage -
              (this.tableOptionsBirthInfo.itemsPerPage -
                res.data.birthInfoData.num_rows);
            this.birthLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.birthLoading = false;
        });
    },
    pageChangeBirth(t) {
      if (t)
        this.tableOptionsBirthInfo.page = this.tableOptionsBirthInfo.page + 1;
      else
        this.tableOptionsBirthInfo.page = this.tableOptionsBirthInfo.page - 1;

      this.getBirthInfo();
    },
    async getProductByCat() {
      console.log(this.farm);
      await this.getConception();
      await this.getSemen();
      await this.getEmbryo();
      await this.getPregnancyCheck();
      await this.getBirthInfo();
    },
  },
  mixins: [loadingMixin],
};
</script>
<style lang="scss" scoped>
::v-deep .wdt {
  width: 175px;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
</style>
